﻿var webshop_urls = 
[
     {
        "CountryCode": "AL",
        "Country": "Albanien",
        "Webshops": [
             {
                 "Name": "Zanza",
                 "Url": "https://www.zanzastore.al"
             }
         ]
     },
     {
        "CountryCode": "AU",
        "Country": "Australia",
        "Webshops": [
             {
                 "Name": "birthpartner.com.au",
                 "Url": "https://birthpartner.com.au/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "Bubstuff",
                 "Url": "https://www.bubstuff.com.au/search?type=product&options%5Bprefix%5D=last&q=done+by+deer"
             },
             {
                 "Name": "Danish by Design",
                 "Url": "https://www.danishbydesign.com.au/brand/done-by-deer/"
             },
             {
                 "Name": "designstuff.com.au",
                 "Url": "https://www.designstuff.com.au/brand/done-by-deer/"
             },
             {
                 "Name": "Kettu.com.au",
                 "Url": "https://www.kettu.com.au/collections/done-by-deer"
             },
             {
                 "Name": "KJ Essentials",
                 "Url": "https://kjessentials.com.au/search?q=done+by+deer"
             },
             {
                 "Name": "leoandbella.com.au",
                 "Url": "https://www.leoandbella.com.au/brand/done-by-deer/"
             },
             {
                 "Name": "My Dear Baby",
                 "Url": "https://mydearbaby.com.au/collections/done-by-deer"
             },
             {
                 "Name": "Scandikid",
                 "Url": "https://scandikid.com.au/search?q=done+by+deer"
             },
             {
                 "Name": "Temple and Webster",
                 "Url": "https://www.templeandwebster.com.au/Done-by-Deer-C1957072.html?redir=done+by+deer&rtype=6&dept=0&ust="
             },
             {
                 "Name": "The Nile",
                 "Url": "https://www.thenile.com.au/search?s.q=done+by+deer"
             },
             {
                 "Name": "Tiny Fox",
                 "Url": "https://www.tinyfox.com.au/search?s.q=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "AT",
        "Country": "Austria",
        "Webshops": [
             {
                 "Name": "Babyone",
                 "Url": "https://www.babyone.at/done-by-deer"
             },
             {
                 "Name": "dasMikruli",
                 "Url": "https://mikruli.at/search?q=done+&options%5Bprefix%5D=last"
             },
             {
                 "Name": "Florester Concept Store",
                 "Url": "https://www.floresther-shop.at/"
             },
             {
                 "Name": "Stadtkind",
                 "Url": "https://www.stadtkind-store.at"
             },
             {
                 "Name": "XXXLutz Außenlager Internet",
                 "Url": "https://www.xxxlutz.at"
             },
             {
                 "Name": "XXXLutz Internet AT",
                 "Url": "https://www.xxxlutz.at"
             }
         ]
     },
     {
        "CountryCode": "BE",
        "Country": "Belgium",
        "Webshops": [
             {
                 "Name": "A LITTLE COMPANY BVBA",
                 "Url": "https://www.littlethingz.be/nl/merken/done-by-deer/"
             },
             {
                 "Name": "ANNEKE and JANNEKE",
                 "Url": "https://www.annekejanneke.be/merk/done-by-deer/"
             },
             {
                 "Name": "ARTHUR ET ZOE",
                 "Url": "https://www.shop.arthuretzoe.be/fr/recherche/?keyword=done+by+deer"
             },
             {
                 "Name": "BABY COMPANY BVBA",
                 "Url": "https://www.babycompany.be/merken/done-by-deer"
             },
             {
                 "Name": "BABY PLUS VANDERSTRAETEN",
                 "Url": "https://www.babyplusvanderstraeten.be/nl/zoeken?controller=search&orderby=position&orderway=desc&search_query_cat=0&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "BABY'S CORNER",
                 "Url": "https://www.thebabyscorner.be/nl-be/search?q=done+by+deer"
             },
             {
                 "Name": "BABYARTIKELEN BUYSSE",
                 "Url": "https://www.babyartikelen-buysse.be/done-by-deer"
             },
             {
                 "Name": "BABYCENTER DECORATIE",
                 "Url": "https://www.babycenterhalle.be/brands/done-by-deer/"
             },
             {
                 "Name": "BABYKID",
                 "Url": "https://www.babykid.fr/recherche?controller=search&orderby=position&orderway=desc&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "BB-BOX",
                 "Url": "https://www.bb-box.be/search/done+by+deer/"
             },
             {
                 "Name": "BOLLEBUIK",
                 "Url": "https://www.bollebuik.shop/merk/done-by-deer.html"
             },
             {
                 "Name": "BONBON BABY STORE",
                 "Url": "https://www.bonbon.ooo/collections/done-by-deer"
             },
             {
                 "Name": "CARAMBOLA GCV - JILKO",
                 "Url": "https://www.jilko.be/brand/done-by-deer/"
             },
             {
                 "Name": "COSY BABY",
                 "Url": "https://www.cosybaby.be/merken/done-by-deer"
             },
             {
                 "Name": "DE GELE FLAMINGO",
                 "Url": "https://www.degeleflamingo.com/collections/done-by-deer"
             },
             {
                 "Name": "DE KINDERPLANEET",
                 "Url": "https://www.dekinderplaneet.be/en-us/search?q=done+by+deer&Attrib+1+Code=DONE+BY+DEER"
             },
             {
                 "Name": "DE KLEINE TOVENAAR - KINSCHOTS NICK",
                 "Url": "https://kleinetovenaar.eu/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "De Kleine Zebra",
                 "Url": "https://www.kleinezebra.com/995-done-by-deer"
             },
             {
                 "Name": "DE SPRINGBOON",
                 "Url": "https://www.springboon.be/index.php?route=product/manufacturer/product&manufacturer_id=112"
             },
             {
                 "Name": "Dreambaby ",
                 "Url": "https://www.dreambaby.be/e/fr/db/marques/marque-done-by-deer?#facet:&productBeginIndex:0&facetLimit:&orderBy:&pageView:grid&minP"
             },
             {
                 "Name": "EUROPOINT",
                 "Url": "https://www.europoint.be/module/dtcelasticsearch/elasticsearch?id_elasticsearch=1&search=done+by+deer"
             },
             {
                 "Name": "Grote Schatten",
                 "Url": "https://www.groteschatten.com/done-by-deer-decoratie-kinderkamer-beddengoed"
             },
             {
                 "Name": "HET LAND VAN OOIT",
                 "Url": "https://hetlandvanooit.be/search?type=product%2Carticle%2Cpage%2Ccollection&q=done%20by%20deer*"
             },
             {
                 "Name": "HIP HOP",
                 "Url": "https://www.hiphoi.be/nl/brands/done-by-deer/"
             },
             {
                 "Name": "Hoorens NV",
                 "Url": "https://http://www.hoorens.eu/nl/done-by-deer-17.htm"
             },
             {
                 "Name": "IKISGROOT",
                 "Url": "https://www.ikisgroot.be/search/?search=done+by+deer"
             },
             {
                 "Name": "JILL and JACK BVBA",
                 "Url": "https://www.jillandjack.be/merken/done-by-deer/"
             },
             {
                 "Name": "JULES and JULIETTE",
                 "Url": "https://www.julesetjuliette.be/en/search/done+by+deer/"
             },
             {
                 "Name": "KAMIEL and CO",
                 "Url": "https://http://www.kamielenco.be/online-babyshop/brand/Done-by-Deer/"
             },
             {
                 "Name": "KIDSLOFT",
                 "Url": "https://www.kidsloft.be/brands/done-by-deer/"
             },
             {
                 "Name": "KIDZ CHOICE",
                 "Url": "https://www.kidzchoice.be/brand/done-by-deer/"
             },
             {
                 "Name": "Kili Kili",
                 "Url": "https://www.kilikili.be/?s=done+by+deer"
             },
             {
                 "Name": "KINDERSPECIAALZAAK THILO",
                 "Url": "https://www.thilo.be/brands/done-by-deer/"
             },
             {
                 "Name": "KITTY KIDSYSTEMS",
                 "Url": "https://www.kitty.be/module/iqitsearch/searchiqit?s=Done+by+deer"
             },
             {
                 "Name": "LA FOLIE DU BEBE",
                 "Url": "https://www.lafoliedubebe.be/fr/brand/82-donebydeer"
             },
             {
                 "Name": "MADEMOISELLE TETINE PINCKERS SANDRINE",
                 "Url": "https://www.mademoiselle-tetine.com/recherche?controller=search&s=done+by+deer"
             },
             {
                 "Name": "MAX EN MAXIME",
                 "Url": "https://www.max-maxime.be/zoeken?q=done+by+deer"
             },
             {
                 "Name": "Meneer Giraf",
                 "Url": "https://www.meneer-giraf.be"
             },
             {
                 "Name": "MILA and ME",
                 "Url": "https://www.mila-me.be/brands/done-by-deer/"
             },
             {
                 "Name": "MILALICIOUS",
                 "Url": "https://www.milalicious.be/c-4396971/done-by-deer/"
             },
             {
                 "Name": "MINI PANDA",
                 "Url": "https://www.minipanda.be/brands/done-by-deer/"
             },
             {
                 "Name": "MINI'ON",
                 "Url": "https://www.minionkidstore.com/collections/done-by-deer"
             },
             {
                 "Name": "Monstertjes",
                 "Url": "https://shop.monstertjes.be/brands/done-by-deer/"
             },
             {
                 "Name": "MOUSTACHE LIFESTYLE",
                 "Url": "https://www.little-moustache.be/eng/search?s=done%20by%20deer"
             },
             {
                 "Name": "MULTI BAZAR",
                 "Url": "https://www.multibazar.be/catalogsearch/result/?q=done+by+deer"
             },
             {
                 "Name": "Nu enkel webshop",
                 "Url": "https://www.kidswithflair.com/brands/done-by-deer/"
             },
             {
                 "Name": "OLIVE and MINT",
                 "Url": "https://www.oliveandmint.nl/264-done-by-deer"
             },
             {
                 "Name": "Paradisio Online",
                 "Url": "https://www.paradisio-online.be/zoeken/DONE+BY+DEER/"
             },
             {
                 "Name": "Pimpel and Mees",
                 "Url": "https://www.pimpelenmees.be/search?q=done+by+deer"
             },
             {
                 "Name": "PLAY BY REWIND",
                 "Url": "https://www.rewinddesign.be/collections/done-by-deer"
             },
             {
                 "Name": "ROOM 4 KIDS",
                 "Url": "https://www.room4kids.be/?a=catalog&c=0&search=&brand=Done+by+Deer"
             },
             {
                 "Name": "Supra Bazar WEB",
                 "Url": "https://www.suprabazar.be/module/dtcelasticsearch/elasticsearch?id_elasticsearch=1&search=done+by+deer"
             },
             {
                 "Name": "WITH BABY LOVE",
                 "Url": "https://www.withbabylove.be/search?q=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "BA",
        "Country": "Bosnia-Herzegovina",
        "Webshops": [
             {
                 "Name": "Bimaco d.o.o. Siroki Brijeg",
                 "Url": "https://www.bimaco.net"
             }
         ]
     },
     {
        "CountryCode": "BR",
        "Country": "Brasilien",
        "Webshops": [
             {
                 "Name": "GLC COMERCIO IMPORTACAO E EXPORTACAO S/A / BÛP BAB",
                 "Url": "https://www.bupbaby.com.br"
             }
         ]
     },
     {
        "CountryCode": "BG",
        "Country": "Bulgaria",
        "Webshops": [
             {
                 "Name": "NEXT LEVEL DISTRIBUTION LTD",
                 "Url": "https://HAPPYDAYS.BG"
             }
         ]
     },
     {
        "CountryCode": "CA",
        "Country": "Canada",
        "Webshops": [
             {
                 "Name": "Kidzdistrict",
                 "Url": "https://www.kidzdistrict.com/search?type=product&q=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "CL",
        "Country": "Chile",
        "Webshops": [
             {
                 "Name": "Blue Trading Spa",
                 "Url": "https://www.fashiontoys.cl/collections/done-by-deer"
             },
             {
                 "Name": "Fashiontoys",
                 "Url": "https://www.fashiontoys.cl/collections/done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "CO",
        "Country": "Colombia",
        "Webshops": [
             {
                 "Name": "Estibol S.A.S.",
                 "Url": "https://www.inkanta.com.co/catalogsearch/result/?q=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "CY",
        "Country": "Cyprus",
        "Webshops": [
             {
                 "Name": "SOLIDTRUST LTD",
                 "Url": "https://www.mamatoto.com.cy"
             }
         ]
     },
     {
        "CountryCode": "DK",
        "Country": "Denmark",
        "Webshops": [
             {
                 "Name": "Albert, Emma & Co",
                 "Url": "https://"
             },
             {
                 "Name": "Baby Bus ApS",
                 "Url": "https://www.babybus.dk"
             },
             {
                 "Name": "Babysam",
                 "Url": "https://www.babysam.dk/maerker-done-by-deer"
             },
             {
                 "Name": "Babyshop",
                 "Url": "https://www.babyshop.dk/done-by-deer/s/1356"
             },
             {
                 "Name": "Blå Elefant",
                 "Url": "https://www.blaelefant.dk/maerker/done-by-deer"
             },
             {
                 "Name": "Boozt Fashion Denmark",
                 "Url": "https://www.boozt.com/dk/da/done-by-deer/born "
             },
             {
                 "Name": "Byhappyme.dk",
                 "Url": "https://byhappyme.com/dk/search?controller=search&s=done+by+deer"
             },
             {
                 "Name": "Børnenes Kartel ApS",
                 "Url": "https://www.borneneskartel.dk/produkter/350-done-by-deer/"
             },
             {
                 "Name": "c-centrum.dk",
                 "Url": "https://c-centrum.dk/vare-kategori/brands/done-by-deer/"
             },
             {
                 "Name": "Hjem.dk",
                 "Url": "https://www.hjem.dk"
             },
             {
                 "Name": "HOME-TEX",
                 "Url": "https://www.home-tex.dk"
             },
             {
                 "Name": "House of Mammashop",
                 "Url": "https://www.mammashop.dk/collections/done-by-deer"
             },
             {
                 "Name": "Huggi.dk",
                 "Url": "https://www.huggi.dk"
             },
             {
                 "Name": "Huset No. 17",
                 "Url": "https://husetno17.dk/shop/?brand=225-done-by-deer"
             },
             {
                 "Name": "Illums Bolighus",
                 "Url": "https://www.illumsbolighus.dk/brands/d/done-by-deer"
             },
             {
                 "Name": "Jollyroom",
                 "Url": "https://www.jollyroom.dk/varemarker/done-by-deer"
             },
             {
                 "Name": "Kids Coolshop Svendborg",
                 "Url": "https://kids-coolshop-svendborg.business.site/"
             },
             {
                 "Name": "Kids-world",
                 "Url": "https://www.kids-world.com/en/done-by-deer-c-2222.html"
             },
             {
                 "Name": "Krea Pausen",
                 "Url": "https://"
             },
             {
                 "Name": "Kære børn",
                 "Url": "https://www.kaereboern.dk/produkt-kategori/donebydeer/"
             },
             {
                 "Name": "Legekammeraten",
                 "Url": "https://www.legekammeraten.dk/collections/done-by-deer"
             },
             {
                 "Name": "Legekammeraten",
                 "Url": "https://www.legekammeraten.dk/collections/done-by-deer"
             },
             {
                 "Name": "Loukrudt",
                 "Url": "https://loukrudt.dk/search?type=product%2Carticle%2Cpage&options%5Bprefix%5D=last&q=done+by+deer"
             },
             {
                 "Name": "Luksusbaby",
                 "Url": "https://luksusbaby.dk/shop/done-by-deer-457c1.html"
             },
             {
                 "Name": "Magasin.dk",
                 "Url": "https://www.magasin.dk/maerker/done-by-deer"
             },
             {
                 "Name": "Matas.dk",
                 "Url": "https://www.matas.dk/soeg?search-query=done%20by%20deer"
             },
             {
                 "Name": "Matas.dk",
                 "Url": "https://www.matas.dk/soeg?search-query=done%20by%20deer"
             },
             {
                 "Name": "Neye.dk",
                 "Url": "https://www.neye.dk/brands/done-by-deer/"
             },
             {
                 "Name": "Salling",
                 "Url": "https://www.salling.dk/maerker/legetoej/done-by-deer/c-10013/"
             },
             {
                 "Name": "Stokværk",
                 "Url": "https://www.stokvaerk.dk/varekatalog?search=done+by+deer"
             },
             {
                 "Name": "Titteboo",
                 "Url": "https://www.titteboo.dk/shop/done-by-deer-426c1.html"
             },
             {
                 "Name": "ØnskeBørn",
                 "Url": "https://www.onskeborn.dk/webshop/m%C3%A6rker/done-by-deer"
             },
             {
                 "Name": "Ønskebørn WEB",
                 "Url": "https://www.onskeborn.dk/pl/M%C3%A6rker-Done-By-Deer_451274.aspx"
             }
         ]
     },
     {
        "CountryCode": "EE",
        "Country": "Estonia",
        "Webshops": [
             {
                 "Name": "Fliis Trade OÜ",
                 "Url": "https://http://fliistrade.com/"
             },
             {
                 "Name": "Nordbaby Estonia Web",
                 "Url": "https://www.nordbaby.com/ee/en/brands/done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "FI",
        "Country": "Finland",
        "Webshops": [
             {
                 "Name": "A.T-Lastenturva",
                 "Url": "https://www.lastenturva.fi/merkki/done-by-deer/doneby/"
             },
             {
                 "Name": "Babycity & Pellavapuoti Ky",
                 "Url": "https://www.babycity.fi/"
             },
             {
                 "Name": "Boozt Fashion Finland",
                 "Url": "https://www.boozt.com/fi/fi/done-by-deer/lapset "
             },
             {
                 "Name": "Crocoliini Oy",
                 "Url": "https://www.crocoliini.fi/search/?q=done+by+deer"
             },
             {
                 "Name": "Iloinen Heppu Oy",
                 "Url": "https://www.iloinenheppu.fi/brand/107/donebydeer"
             },
             {
                 "Name": "JR Kodintavaratalo Oy",
                 "Url": "https://www.kodintavaratalo.fi"
             },
             {
                 "Name": "Kauppakeskus Skanssi / Leluliike Casagrande",
                 "Url": "https://"
             },
             {
                 "Name": "Kärkkäinen Oy Keskusvarasto",
                 "Url": "https://www.karkkainen.com"
             },
             {
                 "Name": "Lapsekas Oy",
                 "Url": "https://www.pikkupiia.fi/done-by-deer"
             },
             {
                 "Name": "Lasten Into Oy",
                 "Url": "https://www.lasteninto.fi/epages/intoshop.sf/fi_FI/?ObjectPath=/Shops/2018112709/Categories/Braendit/Done_By_Deer"
             },
             {
                 "Name": "Lasten Satumetsä",
                 "Url": "https://www.lastensatumetsa.fi"
             },
             {
                 "Name": "Leikinaika Oy - Pienikamari",
                 "Url": "https://pienikamari.fi/search/?sort=search&per_page=25&q=done"
             },
             {
                 "Name": "Leluliike Casagrande Oy",
                 "Url": "https://www.casagrande.fi"
             },
             {
                 "Name": "Marimuksu Oy",
                 "Url": "https://marimuksu.fi/collections/done-by-deer"
             },
             {
                 "Name": "OzBaby Varasto",
                 "Url": "https://www.ozbaby.fi/b/done-by-deer/94/"
             },
             {
                 "Name": "Raskauskeiju.fi",
                 "Url": "https://www.raskauskeiju.fi/done-by-deer"
             },
             {
                 "Name": "Roi star Oy",
                 "Url": "https://www.tiinuska.fi/done-deer-m-11.html"
             },
             {
                 "Name": "Sara&Sofia Oy",
                 "Url": "https://sarasofia.fi/search?q=Done+by+deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "Swanie Finland Tmi-Luna Living",
                 "Url": "https://www.swaniefinland.fi/search?q=done+by+deer&options%5Bprefix%5D=last&type=product%2Carticle%2Cpage"
             },
             {
                 "Name": "wauva.com",
                 "Url": "https://www.wauva.com/merkki/done-by-deer/A24AD5E2/"
             },
             {
                 "Name": "You Name It Oy",
                 "Url": "https://"
             }
         ]
     },
     {
        "CountryCode": "FR",
        "Country": "France",
        "Webshops": [
             {
                 "Name": "AUTOUR DE BEBE",
                 "Url": "https://www.autourdebebe.com/c/marque_201702111019/toutes-les-marques/done-by-deer"
             },
             {
                 "Name": "BAMBINOU",
                 "Url": "https://www.bambinou.com/catalogsearch/result/?q=done+by+deer"
             },
             {
                 "Name": "BEBE 9",
                 "Url": "https://www.bebe9.com/marque/done-by-deer.html"
             },
             {
                 "Name": "BLANC DE FALAISE",
                 "Url": "https://www.blancdefalaise.com/brand/4-done-by-deer"
             },
             {
                 "Name": "DOUDOU MALIN",
                 "Url": "https://www.doudoumalin.com/categorie-18649-done_by_deer.html#page_1/0-260//tout"
             },
             {
                 "Name": "DRÖM",
                 "Url": "https://www.dromdesign.fr/156_done-by-deer"
             },
             {
                 "Name": "FABRIQUE DE STYLES",
                 "Url": "https://fabriquedestyles.com"
             },
             {
                 "Name": "FRESH AIR",
                 "Url": "https://www.freshairchamonix.com/fr/index.php?fc=module&module=leoproductsearch&controller=productsearch&leoproductsearch_static_token=b74b7a9e5477d3ada6ca6dd3f0fba115&cate=&search"
             },
             {
                 "Name": "ID KIDS - OKAIDI SAS - OXYBUL",
                 "Url": "https://www.oxybul.com/done-by-deer"
             },
             {
                 "Name": "KING JOUET LOGISTIQUE (8847)",
                 "Url": "https://www.king-jouet.com/"
             },
             {
                 "Name": "L'ARMOIRE DE BEBE",
                 "Url": "https://www.larmoiredebebe.com/b000036433/done-by-deer/"
             },
             {
                 "Name": "LA MAISON DE ZAZOU",
                 "Url": "https://www.lamaisondezazou.com/marque/donebydeer/"
             },
             {
                 "Name": "LE CIEL EST A TOUT LE MONDE 5E",
                 "Url": "https://http://lecielestatoutlemonde.fr/recherche?controller=search&orderby=position&orderway=desc&search_query=done+by+deer&submit_search=Find"
             },
             {
                 "Name": "LES ENFANTS REVEURS",
                 "Url": "https://www.les-enfants-reveurs.com/recherche?controller=search&s=done+by+deer"
             },
             {
                 "Name": "LES JEUX D'EMMA",
                 "Url": "https://www.lesjeuxdemma.fr/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "LES LIONCEAUX",
                 "Url": "https://www.leslionceaux.com"
             },
             {
                 "Name": "LITTLE BY LITTLE",
                 "Url": "https://www.littlecasba.com/recherche?controller=search&order=product.date_add.desc&s=done+by+deer"
             },
             {
                 "Name": "LITTLE CASBA",
                 "Url": "https://www.littlecasba.com/recherche?controller=search&order=product.date_add.desc&s=done+by+deer"
             },
             {
                 "Name": "LITTLE CECILE",
                 "Url": "https://www.little-cecile.com/15_done-by-deer"
             },
             {
                 "Name": "LOULOU IN THE WOODS",
                 "Url": "https://www.loulouinthewoods.com/6_done-by-deer"
             },
             {
                 "Name": "LUPOPE",
                 "Url": "https://lupope.com"
             },
             {
                 "Name": "MADE IN BEBE",
                 "Url": "https://www.madeinbebe.com/done-by-deer/m235"
             },
             {
                 "Name": "MADE4BABY",
                 "Url": "https://www.made4baby.fr/marque/190-done-by-deer"
             },
             {
                 "Name": "MAISON BLEUE",
                 "Url": "https://joliequiberonnaise.fr/"
             },
             {
                 "Name": "MAISON CANAILLES",
                 "Url": "https://maisoncanailles.com"
             },
             {
                 "Name": "MAISON ET MARGOT",
                 "Url": "https://www.maisonetmargot.fr"
             },
             {
                 "Name": "MAISON ROMY",
                 "Url": "https://www.maison-romy.com/"
             },
             {
                 "Name": "MANGER ET GRANDIR",
                 "Url": "https://www.mangeretgrandir.fr"
             },
             {
                 "Name": "MERVEILL HOME",
                 "Url": "https://Merveill-home.com"
             },
             {
                 "Name": "OH LES MÔMES",
                 "Url": "https://www.ohlesmomes.fr"
             },
             {
                 "Name": "OPLA SAS",
                 "Url": "https://"
             },
             {
                 "Name": "ORCHESTRA FRANCE",
                 "Url": "https://fr.shop-orchestra.com/fr/Search-Show?q=Done%20by%20deer"
             },
             {
                 "Name": "ORCHESTRA MAROC",
                 "Url": "https://www.orchestra.ma/fr/recherche.php?search=done+by+der"
             },
             {
                 "Name": "OUISTI' KIDS",
                 "Url": "https://ouistikids.fr/search?q=done+by+deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "OXYBUL",
                 "Url": "https://www.oxybul.com/done-by-deer"
             },
             {
                 "Name": "PERLIN PAON PAON",
                 "Url": "https://www.perlinpaonpaon.com/187_done-by-deer"
             },
             {
                 "Name": "PETIT COEUR SALÉ",
                 "Url": "https://petitcoeursale.fr"
             },
             {
                 "Name": "POW WOW KIDS",
                 "Url": "https://powwowkids.com/marque/done-by-deer/"
             },
             {
                 "Name": "REVE DE PAN",
                 "Url": "https://www.revedepan.com/marque-done-by-deer/"
             },
             {
                 "Name": "SACHANA",
                 "Url": "https://www.sachanakids.com/search-results?q=done+by+deer"
             },
             {
                 "Name": "SARL MEGARA - BERCEAU MAGIQUE",
                 "Url": "https://www.berceaumagique.com/done-by-deer.html"
             },
             {
                 "Name": "SAS HOUSTALET",
                 "Url": "https://www.houstalet.com"
             },
             {
                 "Name": "SLASH TALI",
                 "Url": "https://www.juste-familystore.fr/"
             },
             {
                 "Name": "SMALLABLE",
                 "Url": "https://fr.smallable.com/marques/done-by-deer"
             },
             {
                 "Name": "SO BOHEME",
                 "Url": "https://www.so-boheme.com"
             },
             {
                 "Name": "SPACEFOOT SNEAKIDS",
                 "Url": "https://sneakids.fr"
             },
             {
                 "Name": "TAPE A LOEIL - TAO",
                 "Url": "https://www.t-a-o.com/search?text=done+by+deer"
             },
             {
                 "Name": "TODAY IS SUNDAY_SAS AMC KIDS",
                 "Url": "https://www.today-is-sunday.com"
             },
             {
                 "Name": "TUTUTE ET GRIBOUILLIS",
                 "Url": "https://tututeetgribouillis.fr"
             },
             {
                 "Name": "VERTBAUDET",
                 "Url": "https://www.vertbaudet.fr/coffret-repas-4-pieces-done-by-deer-goodie-box-stick-stay-en-silicone-bleu-gris-vert.htm?ProductId=341002998&FiltreCouleur=0502&FiltreTaille=TU&tool=reche"
             },
             {
                 "Name": "WESCO",
                 "Url": "https://www.wesco.fr/59883171-arche-d-activites-elephant-done-by-deer.html"
             }
         ]
     },
     {
        "CountryCode": "DE",
        "Country": "Germany",
        "Webshops": [
             {
                 "Name": "",
                 "Url": "https://www.babybrands.de/search?search=done+by+deer"
             },
             {
                 "Name": "A.W. Schütte GmbH + Co. KG",
                 "Url": "https://www.schuettewelt.de/index.php?s=done+by+deer&sa=1"
             },
             {
                 "Name": "Baby Lions",
                 "Url": "https://www.babylions.de/shop/search/?keywords=done%20by%20deer"
             },
             {
                 "Name": "Baby Wirth GmbH",
                 "Url": "https://shop.baby-wirth.de/search?type=product%2Carticle%2Cpage%2Ccollection&options[prefix]=last&q=done%20by%20deer*"
             },
             {
                 "Name": "Baby-Garage.de",
                 "Url": "https://www.baby-garage.de/de/search?sSearch=done%2Bby%2Bdeer&p=1"
             },
             {
                 "Name": "Baby-Walz GmbH",
                 "Url": "https://www.baby-walz.de/done-by-deer/"
             },
             {
                 "Name": "Beabitzer Shop",
                 "Url": "https://www.beabitzer.de/done-by-deer-online-shop"
             },
             {
                 "Name": "Blaue Elefant ",
                 "Url": "https://www.blaueelefant.de/marken/done-by-deer"
             },
             {
                 "Name": "Einfachschön",
                 "Url": "https://www.einfachschoen.com/Hersteller/Done-by-Deer/"
             },
             {
                 "Name": "Fa. Gerhard Hunstig",
                 "Url": "https://www.babyshop.de/Done-by-Deer:.:119.html?MODsid=e9dpi3ak4pi5ms28vg3n0a49o"
             },
             {
                 "Name": "Fantasyroom-Wohnträume für Kinder",
                 "Url": "https://www.my-fantasyroom.de/markendonebydeer-c-1105_2393.html"
             },
             {
                 "Name": "Frau Hansen",
                 "Url": "https://www.frauhansen.de/search?query=done%20by%20deer"
             },
             {
                 "Name": "German Toys",
                 "Url": "https://www.german-toys.com/search?sSearch=done+by+deer"
             },
             {
                 "Name": "Geschenkewerk UG",
                 "Url": "https://www.geschenkewerk-shop.de"
             },
             {
                 "Name": "HabibiLino",
                 "Url": "https://www.habibilino.com/"
             },
             {
                 "Name": "Hobauer GmbH & Co. KG",
                 "Url": "https://www.spielzeugshop-forchheim.de/hobauer-gmbh-co-kg-forchheim/"
             },
             {
                 "Name": "Hoppediz",
                 "Url": "https://hoppediz.de/search/?qs=done+by+deer"
             },
             {
                 "Name": "J.H.Fuhr",
                 "Url": "https://www.fuhr.info"
             },
             {
                 "Name": "Jollyroom",
                 "Url": "https://www.jollyroom.de/marken/done-by-deer"
             },
             {
                 "Name": "Jättefint",
                 "Url": "https://www.jaettefint.de/marken/done-by-deer/?p=1"
             },
             {
                 "Name": "Kind der Stadt",
                 "Url": "https://kind-der-stadt.de"
             },
             {
                 "Name": "Kittyklein",
                 "Url": "https://kittyklein.de/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "Kittyklein",
                 "Url": "https://www.kittyklein.de/epages/es595824.sf/de_DE/?ObjectID=15199745&ViewAction=FacetedSearchProducts&SearchString=done+by+deer"
             },
             {
                 "Name": "Klapperstoch",
                 "Url": "https://www.klapperstorch-umstandsmode.de/"
             },
             {
                 "Name": "Kunterburg",
                 "Url": "https://www.shoppeninmonschau.de"
             },
             {
                 "Name": "Liebes von Priebes",
                 "Url": "https://www.liebesvonpriebes.de"
             },
             {
                 "Name": "LilleKids",
                 "Url": "https://lillekids-onlineshop.de/"
             },
             {
                 "Name": "Maibee - Inh. Anne Lischke",
                 "Url": "https://www.maibee.shop"
             },
             {
                 "Name": "MUNDOmio Kids Store",
                 "Url": "https://mundomio.de/"
             },
             {
                 "Name": "Möbelzentrum Pforzheim",
                 "Url": "https://moebelzentrum-pforzheim.de/"
             },
             {
                 "Name": "Nina König",
                 "Url": "https://www.ninakoenig.de/"
             },
             {
                 "Name": "Out of Alltag GmbH",
                 "Url": "https://www.shop-rikiki.de"
             },
             {
                 "Name": "petit ami Katharina & Kai Schoch GbR",
                 "Url": "https://www.petitami.studio"
             },
             {
                 "Name": "Rock my Sleep GmbH",
                 "Url": "https://rockmysleep.com/"
             },
             {
                 "Name": "Schmatzepuffer.de",
                 "Url": "https://www.schmatzepuffer.de/"
             },
             {
                 "Name": "Sparkle & Pop - Gifts & Events",
                 "Url": "https://www.sparkle-pop.de"
             },
             {
                 "Name": "Thalia Bücher GmbH",
                 "Url": "https://www.thalia.de"
             },
             {
                 "Name": "Vedes Spielwaren bei Dauth in Tübingen",
                 "Url": "https://www.vedes-spielwaren.de/vedes-spielwaren-tuebingen/"
             },
             {
                 "Name": "Vedes Spielwaren im LAGO in Konstanz ",
                 "Url": "https://www.vedes-spielwaren.de/vedes-spielwaren-tuebingen/"
             },
             {
                 "Name": "World of Toys Ringen",
                 "Url": "https://www.worldoftoys.se"
             },
             {
                 "Name": "World of Toys Ringen",
                 "Url": "https://www.worldoftoys.se"
             },
             {
                 "Name": "World of Toys Ringen",
                 "Url": "https://www.worldoftoys.se"
             },
             {
                 "Name": "Wunderwunsch GmbH",
                 "Url": "https://"
             },
             {
                 "Name": "Wupatki",
                 "Url": "https://www.wupatki.shop/brands/donebydeer"
             },
             {
                 "Name": "Yawandoo GmbH",
                 "Url": "https://www.villa-sternenstaub.de/search?search=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "GR",
        "Country": "Greece",
        "Webshops": [
             {
                 "Name": "LAPIN HOUSE",
                 "Url": "https://www.lapinkids.com/el/catalog?query=Done+by+deer&button="
             }
         ]
     },
     {
        "CountryCode": "GL",
        "Country": "Greenland",
        "Webshops": [
             {
                 "Name": "Babysam Nuuk",
                 "Url": "https://www.babysam.gl/varekatalog?search=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "HK",
        "Country": "Hong Kong (China)",
        "Webshops": [
             {
                 "Name": "Babycentral",
                 "Url": "https://babycentral.com.hk/done-by-deer-en"
             },
             {
                 "Name": "Babycentral",
                 "Url": "https://babycentral.com.hk/done-by-deer-en"
             },
             {
                 "Name": "Babycentral",
                 "Url": "https://babycentral.com.hk/done-by-deer-en"
             },
             {
                 "Name": "Jakewell",
                 "Url": "https://jakewell.com.hk/categories/done-by-deer"
             },
             {
                 "Name": "Jakewell",
                 "Url": "https://jakewell.com.hk/categories/done-by-deer"
             },
             {
                 "Name": "Jakewell",
                 "Url": "https://jakewell.com.hk/categories/done-by-deer"
             },
             {
                 "Name": "Kinderspiel Hong Kong",
                 "Url": "https://www.kinderspiel.hk/"
             },
             {
                 "Name": "Kinderspiel Hong Kong",
                 "Url": "https://www.kinderspiel.hk/"
             },
             {
                 "Name": "Kinderspiel Hong Kong",
                 "Url": "https://www.kinderspiel.hk/"
             },
             {
                 "Name": "Oh My Josh Co Limited",
                 "Url": "https://"
             },
             {
                 "Name": "Petit Tippi ",
                 "Url": "https://petittippi.com/"
             },
             {
                 "Name": "Petit Tippi ",
                 "Url": "https://petittippi.com/"
             },
             {
                 "Name": "Petit Tippi ",
                 "Url": "https://petittippi.com/"
             },
             {
                 "Name": "Twins Baby ",
                 "Url": "https://www.twinsbaby.hk/product-category/brand/done-by-deer/"
             },
             {
                 "Name": "Twins Baby ",
                 "Url": "https://www.twinsbaby.hk/product-category/brand/done-by-deer/"
             },
             {
                 "Name": "Twins Baby ",
                 "Url": "https://www.twinsbaby.hk/product-category/brand/done-by-deer/"
             }
         ]
     },
     {
        "CountryCode": "HU",
        "Country": "Hungary",
        "Webshops": [
             {
                 "Name": "Mamas and Papas",
                 "Url": "https://mamasandpapas.hu/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "New Baby Kft.",
                 "Url": "https://mamasandpapas.hu/?s=done+by+deer&post_type=product"
             }
         ]
     },
     {
        "CountryCode": "IE",
        "Country": "Ireland",
        "Webshops": [
             {
                 "Name": "Arnotts",
                 "Url": "https://www.brownthomas.com/search/?q=done+by+deer&lang=en_IE"
             },
             {
                 "Name": "Bella Baby",
                 "Url": "https://www.bellababy.ie/brands/row-3/done-by-deer.html"
             },
             {
                 "Name": "Dada Kids",
                 "Url": "https://dadakids.store"
             },
             {
                 "Name": "Flanagan Harhen Interiors",
                 "Url": "https://flanaganharheninteriors.com/search?q=done+by+deer&type=product%2Carticle%2Cpage&options%5Bprefix%5D=last"
             },
             {
                 "Name": "Kaliedy",
                 "Url": "https://www.kaliedy.com/search?q=done+by+deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "Kool Kidz",
                 "Url": "https://www.babyaccessories.ie"
             },
             {
                 "Name": "LittleBe",
                 "Url": "https://www.littlebe.com"
             },
             {
                 "Name": "Tralee Nursery Supplies",
                 "Url": "https://traleenurserysupplies.com/"
             },
             {
                 "Name": "Unbound",
                 "Url": "https://unbound.ie/search?q=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "IL",
        "Country": "Israel",
        "Webshops": [
             {
                 "Name": "BABY STAR MOTZAREI TINOKOT LTD",
                 "Url": "https://www.baby-star.co.il"
             }
         ]
     },
     {
        "CountryCode": "IT",
        "Country": "Italy",
        "Webshops": [
             {
                 "Name": "APPLE PIE SAS",
                 "Url": "https://applepie.eu/collections/done-by-deer"
             },
             {
                 "Name": "Bassetto Sas",
                 "Url": "https://www.bassettobimbi.com/marchi/done-by-deer.html"
             },
             {
                 "Name": "Family Nation",
                 "Url": "https://www.family-nation.it/done-by-deer-B371.htm"
             },
             {
                 "Name": "Family Nation S.R.L.",
                 "Url": "https://www.buzzitalia.it"
             },
             {
                 "Name": "Gadoola",
                 "Url": "https://www.gadoola.com/catalogo-prodotti/?s-filter=done+by+deer&post_type=product&yith_product_brand-filter=done-by-deer"
             },
             {
                 "Name": "LA CHIOCCIOLA SRL",
                 "Url": "https://www.lachiocciolababy.it/it_it/done_bydeer/"
             }
         ]
     },
     {
        "CountryCode": "XK",
        "Country": "Kosovo",
        "Webshops": [
             {
                 "Name": "OLABA SHOP",
                 "Url": "https://olaba.shop/brendet-tona/?pwb-brand-filter=done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "LV",
        "Country": "Latvia",
        "Webshops": [
             {
                 "Name": "Nordbaby Latvia Web",
                 "Url": "https://www.nordbaby.com/lv/en/brands/done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "LT",
        "Country": "Lithuania",
        "Webshops": [
             {
                 "Name": "Nordbaby Lithuania Web",
                 "Url": "https://www.nordbaby.com/lt/en/brands/done-by-deer"
             },
             {
                 "Name": "UAB Makuja",
                 "Url": "https://little-goose.com/"
             }
         ]
     },
     {
        "CountryCode": "MT",
        "Country": "Malta",
        "Webshops": [
             {
                 "Name": "Swanky Boutique",
                 "Url": "https://www.swankyboutique.com/search?type=product%2Carticle%2Cpage%2Ccollection&options[prefix]=last&q=done%20by%20deer*"
             }
         ]
     },
     {
        "CountryCode": "MN",
        "Country": "Mongolia",
        "Webshops": [
             {
                 "Name": "Mama Papa",
                 "Url": "https://www.mamapapa.mn"
             }
         ]
     },
     {
        "CountryCode": "ME",
        "Country": "Montenegro",
        "Webshops": [
             {
                 "Name": "KIDSLAND retail chain",
                 "Url": "https://www.kidsland.me"
             },
             {
                 "Name": "Oblak i Sunce doo",
                 "Url": "https://www.oblakisunce.me"
             }
         ]
     },
     {
        "CountryCode": "NG",
        "Country": "Nigeria",
        "Webshops": [
             {
                 "Name": "I AM SPECIAL Baby & Kids Store",
                 "Url": "https://iamspecial.ng"
             }
         ]
     },
     {
        "CountryCode": "MK",
        "Country": "North Macedonia",
        "Webshops": [
             {
                 "Name": "Oskar Bebe Dooel",
                 "Url": "https:// www.encimenci.com.mk"
             }
         ]
     },
     {
        "CountryCode": "XI",
        "Country": "Northern Ireland",
        "Webshops": [
             {
                 "Name": "Chocoloons",
                 "Url": "https://chocoloonstoys.com"
             },
             {
                 "Name": "Small Kins",
                 "Url": "https://smallkins.com/collections/done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "NO",
        "Country": "Norway",
        "Webshops": [
             {
                 "Name": "Aktivleker",
                 "Url": "https://aktivlek.no/"
             },
             {
                 "Name": "Aurora Collection AS",
                 "Url": "https://www.auroracollection.no/"
             },
             {
                 "Name": "Babycare AS",
                 "Url": "https://www.babycare.no/merker/donebydeer.html"
             },
             {
                 "Name": "Babyshop",
                 "Url": "https://www.babyshop.no/done-by-deer/s/1356"
             },
             {
                 "Name": "Barnas Hus Nettbutikk",
                 "Url": "https://www.barnashus.no/sok?q=done+by+deer"
             },
             {
                 "Name": "Barneredet",
                 "Url": "https://www.barneredet.no"
             },
             {
                 "Name": "Boozt Fashion Norway",
                 "Url": "https://www.boozt.com/no/no/done-by-deer/barn "
             },
             {
                 "Name": "Feel.no",
                 "Url": "https://feel.no/Search/index/?mod=SearchPage&page_id=&seekwrd=done+by&button="
             },
             {
                 "Name": "Get Inspired AS",
                 "Url": "https://"
             },
             {
                 "Name": "Harmonia AS",
                 "Url": "https://www.harmoniainterior.no"
             },
             {
                 "Name": "Interiør & Eksteriør",
                 "Url": "https://www.greentoys.no/search_result?keywords=done+by+deer#o=relevance"
             },
             {
                 "Name": "Jollyroom",
                 "Url": "https://www.jollyroom.no/varemerker/done-by-deer"
             },
             {
                 "Name": "Krible leker",
                 "Url": "https://www.kribleleker.no"
             },
             {
                 "Name": "Lille Apekatt",
                 "Url": "https://lilleapekatt.no/product/3-i-1-tutekopp-og-snackskopp-croco-done-by-deer/"
             },
             {
                 "Name": "Mimmis.no",
                 "Url": "https://www.mimmis.no/done-by-deer"
             },
             {
                 "Name": "Miniverden AS",
                 "Url": "https://www.miniverden.no/collections/done-by-deer"
             },
             {
                 "Name": "Mushroom AS",
                 "Url": "https://www.barneredet.no"
             },
             {
                 "Name": "Pynten design",
                 "Url": "https://www.pyntendesign.no/"
             },
             {
                 "Name": "Stokke AS",
                 "Url": "https://www.stokke.com"
             },
             {
                 "Name": "Superbarna AS",
                 "Url": "https://www.superbarna.no/search_result?keywords=done+by+deer"
             },
             {
                 "Name": "Varemagasinet Hovs AS",
                 "Url": "https://yesvileker.no/?s=done%20by%20deer"
             }
         ]
     },
     {
        "CountryCode": "PY",
        "Country": "Paraguay",
        "Webshops": [
             {
                 "Name": "Kids - Pensando en tu bebé",
                 "Url": "https://"
             }
         ]
     },
     {
        "CountryCode": "PH",
        "Country": "Philippines",
        "Webshops": [
             {
                 "Name": "RUSTAN COMMERCIAL CORPORATION",
                 "Url": "https://www.rustans.com"
             }
         ]
     },
     {
        "CountryCode": "PL",
        "Country": "Poland",
        "Webshops": [
             {
                 "Name": "4 Kids Point",
                 "Url": "https://4kidspoint.pl/search?options%5Bprefix%5D=last&q=done+by+deer"
             },
             {
                 "Name": "AMKO",
                 "Url": "https://amko.com.pl/firm-pol-1590044056-Done-by-Deer.html"
             },
             {
                 "Name": "Askot",
                 "Url": "https://askot.pl/marka/done-by-deer?page=2"
             },
             {
                 "Name": "Baby By Ann",
                 "Url": "https://www.babybyann.com"
             },
             {
                 "Name": "Baby Fant",
                 "Url": "https://www.babyfant.pl"
             },
             {
                 "Name": "Baby Mama",
                 "Url": "https://www.babymama.pl/pl/searchquery/done+by+deer/1/default/5/f_producer_63/1"
             },
             {
                 "Name": "BabyDeco",
                 "Url": "https://babydeco.eu/pl/searchquery/done+by+deer/1/default/5/url/done%2Cby%2Cdeer/f_producer_124/1"
             },
             {
                 "Name": "Bajka",
                 "Url": "https://bajkasklep.pl/szukaj?controller=search&orderby=position&orderway=desc&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "BEBE Concept",
                 "Url": "https://www.bebeconcept.pl/en/search?q=done+by+deer&options%5Bprefix%5D=last&filter.p.vendor=Done+by+Deer&sort_by=relevance"
             },
             {
                 "Name": "Bebeli",
                 "Url": "https://www.bebeli.pl"
             },
             {
                 "Name": "Bebeoli",
                 "Url": "https://www.kalibaby.pl/PL-H4/oferta/Search.html?query=SZl9rZXl3b3Jkcz07Zl9wcmljZWZvcm09O2ZfcHJpY2V0bz07Zl9wcm9kdWNlbnQ9MzU3O2ZfcGxlYz07Zl9tYXJrPTtzdWJtaXQ9U3p1a2FqOw=="
             },
             {
                 "Name": "Bialy Motylek",
                 "Url": "https://www.bialymotylek.pl/done-by-deer-m-73.html"
             },
             {
                 "Name": "Bimbus",
                 "Url": "https://bimbus.com.pl/kategoria-produktu/marki/done-by-deer/"
             },
             {
                 "Name": "Biomaluch",
                 "Url": "https://www.biomaluch.pl/288_done-by-deer"
             },
             {
                 "Name": "Blueshop",
                 "Url": "https://www.blueshop.pl/szukaj.html?query=done+by+deer"
             },
             {
                 "Name": "Bobomio",
                 "Url": "https://bobomio.pl/done-by-deer"
             },
             {
                 "Name": "Bociek",
                 "Url": "https://www.bociek.eu"
             },
             {
                 "Name": "Bumik",
                 "Url": "https://www.bumik.eu"
             },
             {
                 "Name": "Childsplay",
                 "Url": "https://childsplay.pl/31_done-by-deer"
             },
             {
                 "Name": "Czarodziej",
                 "Url": "https://www.czarodziej.eu"
             },
             {
                 "Name": "E-Baby Stuff",
                 "Url": "https://e-babystuff.pl/producent/done-by-deer/"
             },
             {
                 "Name": "Ebiton24",
                 "Url": "https://www.ebiton24.com"
             },
             {
                 "Name": "EcoBobo",
                 "Url": "https://ecobobo.com/26_done-by-deer"
             },
             {
                 "Name": "Empik",
                 "Url": "https://www.empik.com/szukaj/produkt?q=done%20by%20deer&qtype=basicForm&ac=true"
             },
             {
                 "Name": "Entliczek",
                 "Url": "https://www.entliczek.pl"
             },
             {
                 "Name": "Fabryka Form",
                 "Url": "https://fabrykaform.pl/done-by-deer"
             },
             {
                 "Name": "Fashion Family",
                 "Url": "https://www.fashionfamily.pl/sklep/?filter_marka=done-by-deer"
             },
             {
                 "Name": "For Kids",
                 "Url": "https://www.forkids.pl/pl/producer/done-by-deer/142"
             },
             {
                 "Name": "From Mummy",
                 "Url": "https://www.frommummy.pl/firm-pol-1450176219-Done-by-Deer.html"
             },
             {
                 "Name": "Gamiko Kids",
                 "Url": "https://kotkidwa.pl/firm-pol-1587851039-Done-By-Deer.html"
             },
             {
                 "Name": "Home Like",
                 "Url": "https://www.e-homelike.pl"
             },
             {
                 "Name": "Hops",
                 "Url": "https://sklephops.pl/p,done-by-deer-zawieszka-grzechotka-raffi-pink-40743,8736"
             },
             {
                 "Name": "Jedyny Sklep",
                 "Url": "https://www.jedynysklep.pl/Szukaj.html?query=done+by+deer"
             },
             {
                 "Name": "Kacper i Matylda",
                 "Url": "https://kacper-i-matylda.pl/"
             },
             {
                 "Name": "Kalaluszek",
                 "Url": "https://www.kalaluszek.pl/pl/c/Done-by-Deer/154"
             },
             {
                 "Name": "Kiddies",
                 "Url": "https://www.kiddies.com.pl"
             },
             {
                 "Name": "Kiddy Fave",
                 "Url": "https://kiddyfave.com/listaProduktow.php?dbFin=done+by+deer&szukaj=&kat=0&idz="
             },
             {
                 "Name": "Kinderland24",
                 "Url": "https://www.kinderland24.com.pl/category/marki-done-by-deer"
             },
             {
                 "Name": "Kraina Szkraba",
                 "Url": "https://www.krainaszkraba.pl"
             },
             {
                 "Name": "Les Petits",
                 "Url": "https://www.lespetits.pl"
             },
             {
                 "Name": "Little Room",
                 "Url": "https://www.littleroom.pl"
             },
             {
                 "Name": "Lullaby",
                 "Url": "https://lullaby.com.pl/brands/done-by-deer/"
             },
             {
                 "Name": "Maciuszek ",
                 "Url": "https://maciuszek.com/pl/producer/Done-By-Deer/68/1/full"
             },
             {
                 "Name": "Malama",
                 "Url": "https://www.malama.pl/firm-pol-1533564997-Done-By-Deer.html"
             },
             {
                 "Name": "Malooni",
                 "Url": "https://www.malooni.pl"
             },
             {
                 "Name": "Mama Ania",
                 "Url": "https://mamaania.com.pl/pl/searchquery/done+by+deer/1/phot/5?url=done,by,deer"
             },
             {
                 "Name": "Mama i Ja",
                 "Url": "https://mamaija.pl/producenci/done-by-deer"
             },
             {
                 "Name": "Mama I Tata",
                 "Url": "https://www.mamaitata.waw.pl"
             },
             {
                 "Name": "MamaGama",
                 "Url": "https://www.mamagama.pl/product/search?query=done+by+deer"
             },
             {
                 "Name": "Mamissima",
                 "Url": "https://www.mamissima.pl/done_by_deer.html"
             },
             {
                 "Name": "Mante and Co Design",
                 "Url": "https://www.mantecodesign.pl"
             },
             {
                 "Name": "Meli Melu",
                 "Url": "https://www.melimelu.pl"
             },
             {
                 "Name": "Mi Fili Meble i Akcesoria dla Dzieci",
                 "Url": "https://mifili.pl/szukaj?controller=search&orderby=position&orderway=desc&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "MiloviKids",
                 "Url": "https://www.milovikids.pl"
             },
             {
                 "Name": "Modne Zabawki",
                 "Url": "https://modne-zabawki.pl/szukaj?q=Done+by+Deer"
             },
             {
                 "Name": "Moncziczi",
                 "Url": "https://www.moncziczi.pl/producent/67/done-by-deer"
             },
             {
                 "Name": "Morelkowe",
                 "Url": "https://www.morelkowe.pl/produkty,szukaj?q=done+by+deer"
             },
             {
                 "Name": "Multicotton",
                 "Url": "https://www.multicotton.pl"
             },
             {
                 "Name": "Muppetshop",
                 "Url": "https://www.muppetshop.eu"
             },
             {
                 "Name": "My Sweet Room",
                 "Url": "https://mysweetroom.pl/30_done-by-deer"
             },
             {
                 "Name": "Napiki",
                 "Url": "https://napiki.pl/34_done-by-deer"
             },
             {
                 "Name": "Nodik",
                 "Url": "https://nodik.pl/advanced_search_result.php?keywords=done+by+deer"
             },
             {
                 "Name": "NoNo Store",
                 "Url": "https://nono-store.pl/kategoria-produktu/marki/done-by-deer/"
             },
             {
                 "Name": "Och and Foch",
                 "Url": "https://ochfoch.pl/szukaj?q=done+by+deer"
             },
             {
                 "Name": "Od narodzin",
                 "Url": "https://odnarodzin.pl/brand/done-by-deeer/"
             },
             {
                 "Name": "Pan Piksel Monika Piotrowska-Tubek",
                 "Url": "https://panpiksel.pl/brand/54-done-by-deer"
             },
             {
                 "Name": "Pati i Maks",
                 "Url": "https://patiimaks.pl/done-by-deer/"
             },
             {
                 "Name": "Piccolo Tesoro",
                 "Url": "https://piccolotesoro.pl/pwb-brand/done-by-deer/"
             },
             {
                 "Name": "Popaopa",
                 "Url": "https://popaopa.pl/szukaj?controller=search&orderby=quantity&orderway=desc&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "Scankids",
                 "Url": "https://scandikids.pl/pl/21_done-by-deer"
             },
             {
                 "Name": "Slon",
                 "Url": "https://http://www.slonsklep.pl/produkt/szukaj?szukaj=done+by+deer&producent%5B%5D=Done+by+Deer"
             },
             {
                 "Name": "Sloneczko",
                 "Url": "https://www.zabawkisloneczko.pl"
             },
             {
                 "Name": "Smyk",
                 "Url": "https://www.smyk.com/search?q=done%20by%20deer"
             },
             {
                 "Name": "Smykoland",
                 "Url": "https://www.smykoland.pl"
             },
             {
                 "Name": "So Cozy",
                 "Url": "https://www.socozy.pl"
             },
             {
                 "Name": "Studio Petito",
                 "Url": "https://studiopetito.pl/233-done-by-deer"
             },
             {
                 "Name": "Sweet Home",
                 "Url": "https://kolibelek.pl/tag-produktu/done-by-deer/"
             },
             {
                 "Name": "Sweet home",
                 "Url": "https://www.sweethomebaby.pl"
             },
             {
                 "Name": "Swiat Dziecka",
                 "Url": "https://www.swiatdziecka.com.pl"
             },
             {
                 "Name": "Tobi",
                 "Url": "https://tobisklep.pl/szukaj?controller=search&s=done+by+deer"
             },
             {
                 "Name": "Tomi",
                 "Url": "https://www.tomi.pl/done-by-deer/"
             },
             {
                 "Name": "Tublu",
                 "Url": "https://www.tublu.pl/marki/done-by-deer.html"
             },
             {
                 "Name": "Zabawki Niebanalne",
                 "Url": "https://zabawkiniebanalne.pl/pl/producer/done-by-deer/150"
             },
             {
                 "Name": "Zyrafy z Szafy",
                 "Url": "https://zyrafyzszafy.pl/pl/searchquery/done+by+deer/1/phot/5?url=done,by,deer"
             }
         ]
     },
     {
        "CountryCode": "PT",
        "Country": "Portugal",
        "Webshops": [
             {
                 "Name": "A CEGONHA - TERNURAS & TROPELIAS LDA",
                 "Url": "https://acegonha.pt/?srsltid=AfmBOopZNdSTWYAGcYyyxgZ2nZO0umJK3C-srjSabrwid69oApf-I3wz"
             },
             {
                 "Name": "BABY´S LOVE",
                 "Url": "https://"
             },
             {
                 "Name": "BABYGOLD",
                 "Url": "https://www.babygold.pt/pt/marcas/done-by-deer_1057.html"
             },
             {
                 "Name": "Espaco Mamãs Web",
                 "Url": "https://www.espacomamas.pt/marcas/done-by-deer"
             },
             {
                 "Name": "LOLLA KIDS",
                 "Url": "https://www.lollakids.com/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "MOON BABY",
                 "Url": "https://www.moonbaby.pt"
             },
             {
                 "Name": "My baby´s Boutique",
                 "Url": "https://"
             },
             {
                 "Name": "ORIGEM",
                 "Url": "https://"
             },
             {
                 "Name": "PEANUT - ARTIGOS DE PUERICULTURA, LDA",
                 "Url": "https://www.peanut.pt/search-results-page/done%20by%20deer"
             },
             {
                 "Name": "SITIO DO BEBE-SIGMAWEB, LDA",
                 "Url": "https://www.sitiodobebe.com/marca/done-by-deer/"
             },
             {
                 "Name": "Sublinhar, Lda - bybebé Eiras",
                 "Url": "https://"
             }
         ]
     },
     {
        "CountryCode": "RO",
        "Country": "Romania",
        "Webshops": [
             {
                 "Name": "Bonlavie",
                 "Url": "https://bonlavie.ro/"
             },
             {
                 "Name": "Bunnyboo",
                 "Url": "https://www.bunnyboo.ro"
             },
             {
                 "Name": "Elpi",
                 "Url": "https://elpi.ro/search?q=done+by+deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "ERFI KIDS SRL",
                 "Url": "https://www.erfi.ro"
             },
             {
                 "Name": "Marajou",
                 "Url": "https://www.marajou.ro"
             },
             {
                 "Name": "Minni Me Store",
                 "Url": "https://www.minnime.ro/en/catalog?q=done+by+deer"
             },
             {
                 "Name": "Petit Bebe",
                 "Url": "https://www.petit-bebe.ro"
             },
             {
                 "Name": "Soricelul Micut",
                 "Url": "https://soricelulmicut.com/search?q=done+by+deer"
             },
             {
                 "Name": "Taramul Piticilor",
                 "Url": "https://www.taramulpiticilor.ro/catalog?q=done+by+deer"
             },
             {
                 "Name": "The Home",
                 "Url": "https://www.thehome.ro/kids/done-by-deer"
             },
             {
                 "Name": "Tommi",
                 "Url": "https://www.tommi.ro/produse?c=done+by+deer"
             }
         ]
     },
     {
        "CountryCode": "SA",
        "Country": "Saudi Arabia",
        "Webshops": [
             {
                 "Name": "Mumzworld.com",
                 "Url": "https://www.mumzworld.com/en/done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "SI",
        "Country": "Slovenia",
        "Webshops": [
             {
                 "Name": "AKIDS d.o.o.",
                 "Url": "https://www.babycenter.si"
             }
         ]
     },
     {
        "CountryCode": "ZA",
        "Country": "South Africa",
        "Webshops": [
             {
                 "Name": "Kidsliving",
                 "Url": "https://kidsliving.co.za/collections/vendors?q=done%20by%20deer"
             }
         ]
     },
     {
        "CountryCode": "ES",
        "Country": "Spain",
        "Webshops": [
             {
                 "Name": "ABITARE KIDS",
                 "Url": "https://abitare-kids.es/marcas/done-by-deer/"
             },
             {
                 "Name": "Agro Invest Mas Massot, S.L.",
                 "Url": "https://www.eltrenet.cat/ca/cercador/?text=done+by+deer"
             },
             {
                 "Name": "ALADINO",
                 "Url": "https://www.calzadosaladino.com"
             },
             {
                 "Name": "ALECRIM	",
                 "Url": "https://www.alecrim.es/"
             },
             {
                 "Name": "ALUPÉ",
                 "Url": "https://www.alupe.es/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "BABY SECRETS",
                 "Url": "https://babysecrets.es/search?q=done+by+deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "BABY UNIVERSO, S.L.U.-ALI BEBÉ",
                 "Url": "https://alibebe.es/jugar/juguetes-bebes-ninos/peluches/peluche-grande-blandito-de-done-by-deer#/"
             },
             {
                 "Name": "BABY'S ELCHE, S.L.",
                 "Url": "https://www.babysonline.es/1529_done-by-deer"
             },
             {
                 "Name": "BAMBINOS LA TIENDA DE LOS PEQUES, S.L.",
                 "Url": "https://www.tiendasbambinos.com/search-results/q-done%2520by%2520deer"
             },
             {
                 "Name": "BITTI",
                 "Url": "https://www.bitti.es/en/donebydeer"
             },
             {
                 "Name": "BITTI BEBE SL",
                 "Url": "https://www.bitti.es/es/donebydeer"
             },
             {
                 "Name": "BIZCOCHO DE YOGUR",
                 "Url": "https://bizcochodeyogurshop.com/search?type=product&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last&q=Done+by+deer"
             },
             {
                 "Name": "CARLITOS BABY",
                 "Url": "https://carlitosbaby.com/buscar?controller=search&orderby=position&orderway=desc&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "Chiquitines",
                 "Url": "https://www.chiquitines.net/index.php?route=product/manufacturer/info&manufacturer_id=77"
             },
             {
                 "Name": "Coches y Cunas Goyvi 2017 S.L.",
                 "Url": "https://goyvi.es/brand/205-done-by-deer"
             },
             {
                 "Name": "CUCUT",
                 "Url": "https://www.espaicucut.com"
             },
             {
                 "Name": "DIEGABEL, S.L. - MOMS & BABIES",
                 "Url": "https://http://momsandbabies.es/es/module/wtblocksearch/catesearch?fc=module&module=wtblocksearch&controller=catesearch&orderby=position&orderway=desc&search_category=all&search_query=done"
             },
             {
                 "Name": "DON BEBE MUNDO INFANTIL, S.L.",
                 "Url": "https://www.bebecenter.es/buscar?controller=search#/embedded/query=done%20by%20deer&page=1&query_name=match_and&session_id=a186e8e3b5209eddec72e2a73e7b6d96"
             },
             {
                 "Name": "Donosbebe S.L.U.",
                 "Url": "https://mamanbebe.es/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "DRA! - Drandenda, S.L.",
                 "Url": "https://www.juguetes.dradendak.com/es/113_done-by-deer"
             },
             {
                 "Name": "EL MUNDO DE MICO",
                 "Url": "https://elmundodemico.com/#/dfclassic/query=done%20by%20deer&query_name=match_and"
             },
             {
                 "Name": "EXPERIENCIA BEBÉ",
                 "Url": "https://www.experienciabebe.com/es/buscar?controller=search&s=done+by+deer"
             },
             {
                 "Name": "FARRES INTEX S.L. - JOGUIBA",
                 "Url": "https://www.joguiba.com/#8d16/fullscreen/f[brand][]=Done+By+Deer&m=and&q=done+by+deer"
             },
             {
                 "Name": "FONT ESPASA, S.L.",
                 "Url": "https://fontweb.cat/es/busqueda?ticats=0&s=done+by+deer"
             },
             {
                 "Name": "HOME ALCAÑIZ",
                 "Url": "https://"
             },
             {
                 "Name": "INFANTDECO",
                 "Url": "https://www.infantdeco.es/brand/done-by-deer/"
             },
             {
                 "Name": "INQUIETS",
                 "Url": "https://www.inquietsstore.com/ca/resultats-buscador?SEARCH=done%20by%20deer"
             },
             {
                 "Name": "JAN FRIENDS AND PETS, S.L.",
                 "Url": "https://www.janandfriends.com/es/86_done-by-deer"
             },
             {
                 "Name": "JOSTAMENDI - SAN SEBASTIÁN",
                 "Url": "https://jostamendittikiak.com/busqueda?controller=search&s=done+by+deer"
             },
             {
                 "Name": "JUGAJOC",
                 "Url": "https://www.jugajoc.com"
             },
             {
                 "Name": "JUGUIJUGA, S.L",
                 "Url": "https://www.juguijuga.com/busqueda?controller=search&s=done+by+deer"
             },
             {
                 "Name": "KEKOS BEBÉS, S.L.",
                 "Url": "https://www.kekosbebes.com/buscador/done-by-deer"
             },
             {
                 "Name": "KIVA",
                 "Url": "https://www.kivadeko.es"
             },
             {
                 "Name": "LA CASETA DEL LLEO SL",
                 "Url": "https://www.lacasetadellleo.com"
             },
             {
                 "Name": "LA TIENDA DE PEQUES",
                 "Url": "https://www.lateindadepeques.com"
             },
             {
                 "Name": "LA TRIBU LITTLE KIDS",
                 "Url": "https://"
             },
             {
                 "Name": "LES 4 LLUNES, S.L.",
                 "Url": "https://www.las4lunas.es/marcas/done-by-deer/"
             },
             {
                 "Name": "MAMA KOALA",
                 "Url": "https://www.mamakoala.com"
             },
             {
                 "Name": "MEITAIMAITIE",
                 "Url": "https://www.meitaimaitie.com/brand/done-by-deer/"
             },
             {
                 "Name": "Mi Mami Es Lista",
                 "Url": "https://www.mimamieslista.com/27_done-by-deer"
             },
             {
                 "Name": "MIMAMIESLISTA",
                 "Url": "https://www.mimamieslista.com/27_done-by-deer"
             },
             {
                 "Name": "MIMICOS CALATAYUD",
                 "Url": "https://www.mimicoscalatayud.com"
             },
             {
                 "Name": "MIMUS GIRONA S.L.",
                 "Url": "https://www.mimusfamily.com/mimus-shop/?yith_brand_filter=done-by-deer"
             },
             {
                 "Name": "MONJOC, S.C.",
                 "Url": "https://www.monjoc.com/done-by-deer/"
             },
             {
                 "Name": "NENENA PUERICULTURA, S.L.",
                 "Url": "https://nenena.com/26_done-by-deer"
             },
             {
                 "Name": "NOARI - MATARÓ",
                 "Url": "https://www.noari.store/brands/done-by-deer/"
             },
             {
                 "Name": "NOMADAS KIDS",
                 "Url": "https://nomadaskids.com/"
             },
             {
                 "Name": "ORCHESTRA  OPI PRENDAS INFANTILES SL ",
                 "Url": "https://www.es.shop-orchestra.com/es/home"
             },
             {
                 "Name": "PARAFARMACIA OCIOPIA SLU",
                 "Url": "https://"
             },
             {
                 "Name": "PEQUEÑOS VIAJEROS ACM",
                 "Url": "https://www.pequeñosviajeros.es"
             },
             {
                 "Name": "PETIT ABU",
                 "Url": "https://petitabu.com/collections/done-by-deer"
             },
             {
                 "Name": "PK KIDS PUERICULTURA",
                 "Url": "https://"
             },
             {
                 "Name": "PUERICULTURA LARA",
                 "Url": "https://www.puericulturalara.com/"
             },
             {
                 "Name": "SMALLS BY COLLANTES",
                 "Url": "https://www.smalls.es/manufacturers/done-by-deer.html"
             },
             {
                 "Name": "Suit Beibi",
                 "Url": "https://suitbeibi.com/?s=done+by+deer&post_type=product"
             },
             {
                 "Name": "TOBOGAN ZERO SL",
                 "Url": "https://"
             },
             {
                 "Name": "TRADEINN RETAIL SERVICES SL",
                 "Url": "https://www.tradeinn.com/kidinn/?products_search%5Bquery%5D=done%20by%20deer"
             },
             {
                 "Name": "TUPUPEPE",
                 "Url": "https://www.tupupepe.es"
             },
             {
                 "Name": "Tutete.com",
                 "Url": "https://www.tutete.com/tienda/es/man561_done-by-deer.html"
             },
             {
                 "Name": "www.dulcebebe.com",
                 "Url": "https://www.dulcebebe.com/index.php?route=product/manufacturer/info&manufacturer_id=175"
             }
         ]
     },
     {
        "CountryCode": "SE",
        "Country": "Sweden",
        "Webshops": [
             {
                 "Name": "Adlibris AB",
                 "Url": "https://www.adlibris.com/se/sok?q=done+by+deer&pn=2&ps=12&filter=brand%3adone+by+deer"
             },
             {
                 "Name": "Alfred och jag AB",
                 "Url": "https://www.alfredochjag.se"
             },
             {
                 "Name": "Apohem AB",
                 "Url": "https://www.apohem.se/sok?q=done+by+deer"
             },
             {
                 "Name": "Apotea AB",
                 "Url": "https://www.apotea.se"
             },
             {
                 "Name": "Apotea AB",
                 "Url": "https://www.apotea.se"
             },
             {
                 "Name": "Apotea AB",
                 "Url": "https://www.apotea.se"
             },
             {
                 "Name": "Apotek Hjärtat E-apotek",
                 "Url": "https://www.apotekhjartat.se/soksida/?query=done+by+deer"
             },
             {
                 "Name": "Art'N'Design",
                 "Url": "https://www.artndesign.se/produkt-kategori/varumaerken/done-by-deer/"
             },
             {
                 "Name": "Baby Brands Nordic AB",
                 "Url": "https://www.kopbarnvagn.se"
             },
             {
                 "Name": "Baby V AB",
                 "Url": "https://www.babyv.se/sv/trademarks/45/done-by-deer"
             },
             {
                 "Name": "Babyfy AB",
                 "Url": "https://babyfy.se/"
             },
             {
                 "Name": "Babyland Online Nordic AB",
                 "Url": "https://www.babyland.se/done-by-deer"
             },
             {
                 "Name": "Babyshop",
                 "Url": "https://www.babyshop.se/done-by-deer/s/1356"
             },
             {
                 "Name": "Blå Elefant ",
                 "Url": "https://www.blaelefant.se/varumarke/done-by-deer"
             },
             {
                 "Name": "BONTI AB Odenplan",
                 "Url": "https://www.bonti.se/varumarke/done-by-deer/"
             },
             {
                 "Name": "Boozt Fashion AB",
                 "Url": "https://www.boozt.com/se/sv/done-by-deer/barn "
             },
             {
                 "Name": "Borett Interiör AB",
                 "Url": "https://www.awesmstore.se/brand.html/done-by-deer"
             },
             {
                 "Name": "Bring Shelfless Stockholm",
                 "Url": "https://www.libero.se/liberoklubben/poangshoppen/"
             },
             {
                 "Name": "Butik Karamellen",
                 "Url": "https://butikkaramellen.se/leksaker/done-by-deer/aktivitetsring-lalee"
             },
             {
                 "Name": "C&H Access i Gävle AB",
                 "Url": "https://stuff4kids.se/search?type=product&q=done+by+deer"
             },
             {
                 "Name": "Cooking & Living Sweden AB",
                 "Url": "https://www.cookingandliving.se"
             },
             {
                 "Name": "CPW Group AB",
                 "Url": "https://babywebben.se"
             },
             {
                 "Name": "DOFFI BUTIKEN FÖR BARN OCH BAB",
                 "Url": "https://www.doffi.se/sv/produkter/done-by-deer/"
             },
             {
                 "Name": "EasyComm AB",
                 "Url": "https://www.fuchsundkiwi.de"
             },
             {
                 "Name": "Homeofnordic.se",
                 "Url": "https://homeofnordic.se"
             },
             {
                 "Name": "Iems Asecs AB",
                 "Url": "https://www.iems.se/varumarken/donebydeer/"
             },
             {
                 "Name": "Illums Bolighus",
                 "Url": "https://www.illumsbolighus.se/sok?search-button=&q=done+by+deer&lang=sv_SE"
             },
             {
                 "Name": "Illums bolighus",
                 "Url": "https://www.illumsbolighus.se/varumarken/d/done-by-deer"
             },
             {
                 "Name": "Illums bolighus",
                 "Url": "https://www.illumsbolighus.se/varumarken/d/done-by-deer"
             },
             {
                 "Name": "Illums Bolighus Malmö",
                 "Url": "https://www.illumsbolighus.se/sok?search-button=&q=done+by+deer&lang=sv_SE"
             },
             {
                 "Name": "Illums Bolighus Täby",
                 "Url": "https://www.illumsbolighus.se/brands/done-by-deer"
             },
             {
                 "Name": "Jollyroom AB",
                 "Url": "https://www.jollyroom.se/varumarken/done-by-deer"
             },
             {
                 "Name": "Krokodila",
                 "Url": "https://www.krokodila.se/category/done-by-deer"
             },
             {
                 "Name": "Lekbox",
                 "Url": "https://lekbox.se/"
             },
             {
                 "Name": "Lillasyster&Storebror ab",
                 "Url": "https://storken.com"
             },
             {
                 "Name": "Lunabe",
                 "Url": "https://"
             },
             {
                 "Name": "MEDS Apotek AB",
                 "Url": "https://www.meds.se/done-by-deer/"
             },
             {
                 "Name": "Mini Atelier",
                 "Url": "https://"
             },
             {
                 "Name": "Minilandet.se / MIXOVA HB",
                 "Url": "https://minilandet.se/sok/Done%20by%20deer"
             },
             {
                 "Name": "Minilove AB",
                 "Url": "https://www.minilove.se/done-by-deer"
             },
             {
                 "Name": "Mininook",
                 "Url": "https://"
             },
             {
                 "Name": "NK logistikcenter - Bonti AB",
                 "Url": "https://www.bonti.se/varumarke/done-by-deer/"
             },
             {
                 "Name": "Nordic Nest AB",
                 "Url": "https://www.nordicnest.se/varumarken/done-by-deer/"
             },
             {
                 "Name": "Reskompaniet",
                 "Url": "https://www.reskompaniet.se/"
             },
             {
                 "Name": "Shopping4net",
                 "Url": "https://www.shopping4net.se/Leksaker/Tillverkare/Done-by-Deer.htm"
             },
             {
                 "Name": "TFH Europa AB",
                 "Url": "https://www.tfhsensory.se"
             },
             {
                 "Name": "Väskkompaniet",
                 "Url": "https://xn--vskkompaniet-gcb.se/"
             },
             {
                 "Name": "World of Toys Gallerian",
                 "Url": "https://www.worldoftoys.se"
             },
             {
                 "Name": "Zoza kids store",
                 "Url": "https://www.zozakidsstore.se"
             }
         ]
     },
     {
        "CountryCode": "TW",
        "Country": "Taiwan",
        "Webshops": [
             {
                 "Name": "Comechance Pharmacy",
                 "Url": "https://www.hohobuy.com.tw/products?query=done%20by%20deer"
             },
             {
                 "Name": "Doudou 352",
                 "Url": "https://www.douuob.com/products?query=done%20by%20deer"
             },
             {
                 "Name": "Doudou Tainan",
                 "Url": "https://www.douuob.com/products?query=done%20by%20deer"
             },
             {
                 "Name": "Giggle Baby",
                 "Url": "https://www.gigglebaby.waca.tw"
             },
             {
                 "Name": "Insects Baby",
                 "Url": "https://www.insectsbaby.com.tw/page/product/p02.aspx?kw=done+by+deer"
             },
             {
                 "Name": "Insects Baby",
                 "Url": "https://www.insectsbaby.com.tw/page/product/p02.aspx?kw=done+by+deer"
             },
             {
                 "Name": "Petite boite",
                 "Url": "https://www.petiteboite.net/pages/donebydeer-taiwan"
             },
             {
                 "Name": "Rear House",
                 "Url": "https://shopee.tw/mall/search?keyword=done%20by%20deer&shop=49937260"
             },
             {
                 "Name": "Rear House - T.S. Mall",
                 "Url": "https://shopee.tw/mall/search?keyword=done%20by%20deer&shop=49937260"
             },
             {
                 "Name": "Wawa World - Feng Shan",
                 "Url": "https://www.wawaworld.com.tw/product_list.asp?srch_title=done+by+deer&searchsubmit="
             },
             {
                 "Name": "Wawa World - Fu Kuo",
                 "Url": "https://www.wawaworld.com.tw/product_list.asp?srch_title=done+by+deer&searchsubmit="
             }
         ]
     },
     {
        "CountryCode": "NL",
        "Country": "The Netherlands",
        "Webshops": [
             {
                 "Name": "9up9down",
                 "Url": "https://www.9up9down.nl/"
             },
             {
                 "Name": "Appeltje baby en kinderboetiek",
                 "Url": "https://www.appeltjeleerdam.nl/?filter_merk=done-by-dear&s=done+by+deer&post_typ"
             },
             {
                 "Name": "Babycare Veendam",
                 "Url": "https://www.babycare.nl/en/shopby?merk=1769"
             },
             {
                 "Name": "Babydump",
                 "Url": "https://www.baby-dump.nl/merken/done-by-deer/"
             },
             {
                 "Name": "Babydump BV",
                 "Url": "https://www.baby-dump.nl/merken/done-by-deer/"
             },
             {
                 "Name": "Babypark",
                 "Url": "https://www.babypark.nl/merken/done-by-deer.html"
             },
             {
                 "Name": "Babyplanet Drachten",
                 "Url": "https://www.babyplanet.nl/catalogsearch/result/?q=done+by+deer#sqr:(q[done%20by%20deer])"
             },
             {
                 "Name": "Babywinkel",
                 "Url": "https://www.babywinkel.nl/?ss360Query=done%20by%20deer"
             },
             {
                 "Name": "Balune",
                 "Url": "https://www.balune.nl/search/done+by+deer/"
             },
             {
                 "Name": "Balune",
                 "Url": "https://www.balune.nl/search/done+by+deer/"
             },
             {
                 "Name": "Beebie Westland",
                 "Url": "https://beebie.nl/merk/Done%20by%20Deer"
             },
             {
                 "Name": "Bij Broer en Zus",
                 "Url": "https://www.bijbroerenzus.nl/search/done+by+deer/"
             },
             {
                 "Name": "Billybob Kids Roermond",
                 "Url": "https://www.billybobkids.nl/store1/search?keywords=done%20by%20deer"
             },
             {
                 "Name": "Boutique Rose",
                 "Url": "https://www.boutiquerose.nl/"
             },
             {
                 "Name": "Bruun de Beer",
                 "Url": "https://www.bruundebeer.nl/zoeken?controller=search&orderby=dateadd&orderway=asc&search_query=done+by+deer&submit_search=Zoeken"
             },
             {
                 "Name": "Casteleyn - Alles voor baby",
                 "Url": "https://www.webshopcasteleyn.nl/brands/done-by-deer/"
             },
             {
                 "Name": "de Bijenkorf",
                 "Url": "https://www.debijenkorf.nl/product-lister-page.html?SearchTerm=done%20by%20deer"
             },
             {
                 "Name": "De Lange Tafel",
                 "Url": "https://delangetafel.com/"
             },
             {
                 "Name": "Elena Clothing (JPH Amsterdam)",
                 "Url": "https://www.jphstore.nl/en/search/done+by+deer/"
             },
             {
                 "Name": "Faire Wholesale B.V.",
                 "Url": "https://"
             },
             {
                 "Name": "Gompie Zeeland",
                 "Url": "https://donibydeer.com/en-dk"
             },
             {
                 "Name": "Greetz",
                 "Url": "https://www.greetz.nl/baby-kids/done-by-deer?_=3388516853"
             },
             {
                 "Name": "Het Appeltaartgevoel",
                 "Url": "https://www.hetappeltaartgevoel.nl/webshop/"
             },
             {
                 "Name": "Hip & Mama Box",
                 "Url": "https://hipenmamabox.nl/"
             },
             {
                 "Name": "Hippe Kippe",
                 "Url": "https://www.hippekippe.nl"
             },
             {
                 "Name": "Husks",
                 "Url": "https://husks.nl/"
             },
             {
                 "Name": "Ilovespeelgoed",
                 "Url": "https://www.ilovespeelgoed.nl/speelgoedmerken/done-by-deer.html"
             },
             {
                 "Name": "Kelluf Kleertjes",
                 "Url": "https://www.kellufkleertjes.nl/"
             },
             {
                 "Name": "Kidooz",
                 "Url": "https://www.kidooz.nl/brands/done-by-deer/"
             },
             {
                 "Name": "Kids Department",
                 "Url": "https://www.kidsdepartment.nl/"
             },
             {
                 "Name": "Kinderjuweeltjes",
                 "Url": "https://www.kinderjuweeltjes.nl/search/done+by+deer/"
             },
             {
                 "Name": "Kiwikids",
                 "Url": "https://www.kiwikids.nl/c-3616682/done-by-deer/"
             },
             {
                 "Name": "Kleertjes",
                 "Url": "https://www.kleertjes.com/zoeken/?tn_q=done+by+deer"
             },
             {
                 "Name": "Koopman Mode",
                 "Url": "https://www.koopmanmode.nl"
             },
             {
                 "Name": "Le Fanfare",
                 "Url": "https://www.lefanfare.nl/catalogsearch/result/?q=Done+by+deer"
             },
             {
                 "Name": "Lieve mijn",
                 "Url": "https://lievemijn.com/product/activity-gym-met-speelkleed-sea-friends-color-mix/"
             },
             {
                 "Name": "Linijn.nl",
                 "Url": "https://www.linijn.nl/"
             },
             {
                 "Name": "Lobbes",
                 "Url": "https://www.lobbes.nl"
             },
             {
                 "Name": "Mens en Kinders",
                 "Url": "https://http://www.mensenkinders.nl"
             },
             {
                 "Name": "Mevrouw Groen",
                 "Url": "https://shop.mevrouwgroen.nl/products?attribute_Merk=Done+by+Deer"
             },
             {
                 "Name": "Mini & Me",
                 "Url": "https://www.minienme.nl/collections/done-by-deer"
             },
             {
                 "Name": "Miniparade",
                 "Url": "https://www.miniparade.nl/brands/done-by-deer/"
             },
             {
                 "Name": "Mooistekinderkamer",
                 "Url": "https://www.mooistekinderkamer.nl/merken/done-by-deer/"
             },
             {
                 "Name": "Never grow up Babyshop",
                 "Url": "https://www.nevergrowupbabyshop.nl/brands/done-by-deer/"
             },
             {
                 "Name": "Ondersteboven Baby-Kids-Gifts",
                 "Url": "https://onderstebovenpuck.nl/online-kinderkleding-winkel/gifts-accessoires/eten-drinken/done-by-deer-peekabo-cup-elphee-green/"
             },
             {
                 "Name": "Pippaloentje.nl",
                 "Url": "https://www.pippaloentje.nl/?s=Done+by+deer&post_type=product"
             },
             {
                 "Name": "Plustoys",
                 "Url": "https://www.plustoys.nl/index.php?route=product/search&search=done%20by%20deer"
             },
             {
                 "Name": "Prénatal Moeder & Kind",
                 "Url": "https://www.prenatal.nl/donebydeer/"
             },
             {
                 "Name": "PSIKHOUVANJOU",
                 "Url": "https://www.psikhouvanjou.nl/done-by-deer"
             },
             {
                 "Name": "Sjieke Boel",
                 "Url": "https://www.sjiekeboel.nl/"
             },
             {
                 "Name": "Softie baby Musthaves",
                 "Url": "https://info@softiebabymusthaves.nl"
             },
             {
                 "Name": "Studio Sproeten",
                 "Url": "https://www.studiosproeten.nl/search/?search=done+by+deer"
             },
             {
                 "Name": "The Little Green Bag",
                 "Url": "https://www.thelittlegreenbag.nl/new/done-by-deer/"
             },
             {
                 "Name": "Toff & Teddies",
                 "Url": "https://www.toffenteddies.nl/"
             },
             {
                 "Name": "Toverkast",
                 "Url": "https://toverkast.nl/search?q=Done+by+Deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "Troetelaar",
                 "Url": "https://troetelaar.nl/merken/done-by-deer/"
             },
             {
                 "Name": "Ukkies en Pukkies",
                 "Url": "https://www.ukkiesenpukkies.nl/product/done-by-deer-wally-hide-and-seek/"
             },
             {
                 "Name": "Van Asten BabySuperstore",
                 "Url": "https://www.vanastenbabysuperstore.nl/merken/done-by-deer"
             },
             {
                 "Name": "Villa Uk",
                 "Url": "https://www.villa-uk.nl/product-categorie/merken/done-by-deer/"
             },
             {
                 "Name": "We Love Deco",
                 "Url": "https://www.kidsdeco.nl/merken/done-by-deer/"
             },
             {
                 "Name": "We Love Deco BV",
                 "Url": "https://www.kidsdeco.nl/merken/done-by-deer/"
             },
             {
                 "Name": "Wehkamp",
                 "Url": "https://www.wehkamp.nl/merken/done-by-deer"
             },
             {
                 "Name": "Wensenboomkids",
                 "Url": "https://wensenboomkids.nl/"
             },
             {
                 "Name": "Zin In! Kids Conceptstore",
                 "Url": "https://www.zininkidsconceptstore.nl/merken/done-by-deer/?"
             },
             {
                 "Name": "Zoethout",
                 "Url": "https://zoethout.com/?s=done+by+deer&post_type=product&dgwt_wcas=1"
             },
             {
                 "Name": "Zoethout.com B.V.",
                 "Url": "https://zoethout.com/?s=done+by+deer&post_type=product&dgwt_wcas=1"
             }
         ]
     },
     {
        "CountryCode": "AE",
        "Country": "UAE",
        "Webshops": [
             {
                 "Name": "ElliJunior.com",
                 "Url": "https://ellijunior.com/search?type=product&options%5Bunavailable_products%5D=hide&options%5Bprefix%5D=none&q=Done%20by%20deer*"
             },
             {
                 "Name": "Noon.com",
                 "Url": "https://www.noon.com/uae-en/done_by_deer?q=done%20by%20deer"
             },
             {
                 "Name": "Toybox",
                 "Url": "https://www.toybox.ae/collections/donebydeer"
             }
         ]
     },
     {
        "CountryCode": "GB",
        "Country": "United Kingdom",
        "Webshops": [
             {
                 "Name": "About Living",
                 "Url": "https://www.aboutliving.co.uk/designer/done-by-deer/"
             },
             {
                 "Name": "Baby at the Bank",
                 "Url": "https://babyatthebank.co.uk/collections/done-by-deer"
             },
             {
                 "Name": "Baby B",
                 "Url": "https://babybstore.co.uk/"
             },
             {
                 "Name": "Baby Mori",
                 "Url": "https://babymori.com/pages/search-results-page?q=done+by+deer"
             },
             {
                 "Name": "Babylicious",
                 "Url": "https://www.babylicious.org"
             },
             {
                 "Name": "Bambinista",
                 "Url": "https://www.bambinista.com/collections/done-by-deer"
             },
             {
                 "Name": "Bebe K",
                 "Url": "https://bebekmalton.com/"
             },
             {
                 "Name": "Bumpstart Baby Shop",
                 "Url": "https://www.bumpstartbabyshop.co.uk/?srsltid=AfmBOopueKPNG3iUwgXdadHQFoN1HIIuk4EY6MGXc3k2YeByenrl4ktr"
             },
             {
                 "Name": "Car Seat Ninja",
                 "Url": "https://carseatninja.com/?srsltid=AfmBOoq4uhjp3rpEd9dH4JSEyzaR1AuMxABIlgzW58onajclXq70ACuM"
             },
             {
                 "Name": "Cozzy Cuddle Ltd",
                 "Url": "https://www.cozzycuddle.com"
             },
             {
                 "Name": "Delwalden Pram Centre",
                 "Url": "https://www.dewaldensprams.com"
             },
             {
                 "Name": "Eleanor Charles",
                 "Url": "https://www.eleanorcharlesengland.co.uk/"
             },
             {
                 "Name": "Good Little Egg",
                 "Url": "https://www.goodlittleegg.com/search?q=done+by+deer&options%5Bprefix%5D=last"
             },
             {
                 "Name": "House of Bebe Ltd",
                 "Url": "https://www.houseofbebe.co.uk/?srsltid=AfmBOop2Nfqo3cJD07QM6r7zv91PtOS3YTJnne29FdiUJIsHJo-7Bf7m"
             },
             {
                 "Name": "HUS & HEM",
                 "Url": "https://www.husandhem.co.uk/search?controller=search&orderby=position&orderway=desc&search_query=done+by+deer&submit_search="
             },
             {
                 "Name": "John Lewis",
                 "Url": "https://www.johnlewis.com/brand/done-by-deer/_/N-1yziea8"
             },
             {
                 "Name": "Lesters Nursery World",
                 "Url": "https://lesters-nurseryworld.co.uk/"
             },
             {
                 "Name": "Little Bubbas",
                 "Url": "https://www.littlebubbas.co.uk"
             },
             {
                 "Name": "LittleList",
                 "Url": "https://www.littlelist.co.uk"
             },
             {
                 "Name": "My Baby Stroller",
                 "Url": "https://www.mybabystroller.co.uk"
             },
             {
                 "Name": "Natural Baby Shower",
                 "Url": "https://www.naturalbabyshower.co.uk/collections/done-by-deer"
             },
             {
                 "Name": "Naturally Baby",
                 "Url": "https://naturallybaby.co.uk/"
             },
             {
                 "Name": "NEXT",
                 "Url": "https://www.next.co.uk"
             },
             {
                 "Name": "Nonki",
                 "Url": "https://www.nonki.co.uk"
             },
             {
                 "Name": "Saunders & Smalls",
                 "Url": "https://www.saundersandsmalls.co.uk"
             },
             {
                 "Name": "Small Smart",
                 "Url": "https://www.smallsmart.co.uk/search?type=product&q=done*+by*+deer*"
             },
             {
                 "Name": "The Baby Store",
                 "Url": "https://thebabystoreonline.co.uk/"
             },
             {
                 "Name": "The Kid Collective Ltd t/a Scandiborn",
                 "Url": "https://www.scandiborn.co.uk"
             },
             {
                 "Name": "Tickles and Co",
                 "Url": "https://www.ticklesandco.com"
             },
             {
                 "Name": "Urban Avenue",
                 "Url": "https://urbanavenue.co.uk/search?type=product&q=done+by+deer"
             },
             {
                 "Name": "W. J. Daniel & Co. Ltd",
                 "Url": "https://www.danielstores.co.uk/search/done-by-deer"
             }
         ]
     },
     {
        "CountryCode": "US",
        "Country": "United States",
        "Webshops": [
             {
                 "Name": "Amazon USA",
                 "Url": "https://www.amazon.com/donebydeer"
             },
             {
                 "Name": "Danrie LLC",
                 "Url": "https://shopdanrie.com/"
             },
             {
                 "Name": "Growing IVY",
                 "Url": "https://growingivy.xyz/"
             },
             {
                 "Name": "Minnie",
                 "Url": "https://weareminnie.com/"
             },
             {
                 "Name": "The Goose",
                 "Url": "https://thegoosegreenport.com"
             }
         ]
     },
     {
        "CountryCode": "UY",
        "Country": "Uruguay",
        "Webshops": [
             {
                 "Name": "Baby City",
                 "Url": "https://www.babycity.com.uy/shop/search?main_search=done+by+deer&selected_brands=15%2C&selected_order=latest&selected_pricerange=0%3B1000"
             }
         ]
     }
]
